module.exports = __webpack_public_path__ + "static/media/KYC-2x.89296220.jpeg";